/* =============================================================
   FrogDeal — Griglia unica (v1)

   Fa due cose, entrambe SOPRA l'ordine deciso dal riordino bestseller,
   nessuna che lo tocchi:

   1. Calcola i terzetti: tre giochi disponibili che superano la soglia
      spedizione con lo scarto minimo. Ricontrolla la disponibilita' live
      perche' le scorte sono 1-3 copie e l'app sposta gli esauriti in fondo
      solo al giro dopo.

   2. Barra carrello: totale vero da /cart.js (gia' al netto degli sconti
      automatici), quanto manca, e il risparmio sommato — che su un cesto
      di sconti e' la cosa che stanno comprando davvero.

   RIMOSSO: l'allargamento delle card "affare vero" a span 2. `product-card`
   e' del tema e non e' fatto per stare largo il doppio: l'immagine si
   gonfiava a dismisura e il titolo scivolava in fondo, disallineato dalle
   card vicine. Non si allarga la card di qualcun altro sperando che regga.
   Il risalto ora lo dà la sezione "Top offerte" in cima (Liquid), che e' un
   blocco a parte e non riordina niente.

   Niente stato: tutto deriva dall'ordine che l'app ha appena scritto.
   ============================================================= */
(function () {
  'use strict';
  /* Testi dal tema (window.FD_T, 6 set 2026): l'italiano resta come riserva. */
  const T = Object.assign({}, window.FD_T || {});
  const t = function (k, fallback) { return (T[k] != null && T[k] !== '') ? T[k] : fallback; };

  const root = document.querySelector('[data-fd-grid]');
  if (!root) return;

  const FREE_SHIP = (parseFloat(root.getAttribute('data-free-ship')) || 50) * 100;
  const bar = document.querySelector('[data-fd-bar]');
  const grid = root.querySelector('.fd-grid');
  const items = Array.prototype.slice.call(root.querySelectorAll('[data-fd-item]'));
  const trios = Array.prototype.slice.call(root.querySelectorAll('[data-fd-trio]'));

  function n(el, attr) { return parseInt(el.getAttribute(attr), 10) || 0; }

  function money(cents) {
    return (cents / 100).toLocaleString(t('js_locale', 'it-IT'), {
      style: 'currency', currency: 'EUR', minimumFractionDigits: 2,
    });
  }

  /* ---------- 1. Terzetti a tema ----------
     "Tre giochi che sommati fanno 50" e' una calcolatrice.
     "Tre family game a 55" e' un consiglio. La differenza e' la categoria. */

  function readItem(el) {
    return {
      handle: el.getAttribute('data-handle'),
      title: el.getAttribute('data-title'),
      price: n(el, 'data-price'),
      compare: n(el, 'data-compare'),
      disc: n(el, 'data-disc'),
      wish: n(el, 'data-wish'),
      exp: el.getAttribute('data-exp') === '1',
      bgg: n(el, 'data-bgg'),
      cats: (el.getAttribute('data-cats') || '').split('|').filter(Boolean),
      tipo: (el.getAttribute('data-tipo') || '').split('|').filter(Boolean),
      lingua: (el.getAttribute('data-lingua') || '').split('|').filter(Boolean),
      pmax: n(el, 'data-pmax'),
      eta: n(el, 'data-eta'),
      variantId: el.getAttribute('data-variant-id'),
      img: el.getAttribute('data-img'),
      url: el.getAttribute('data-url'),
    };
  }

  /* Categorie troppo generiche per essere un consiglio: meta' catalogo e'
     "Strategia", quindi "tre giochi di strategia" non dice niente a nessuno. */
  const CAT_TROPPO_LARGHE = ['Strategia', 'Competitivo', 'Tematici'];

  /* Come si legge una categoria in italiano corrente */
  const CAT_FRASE = {
    'Family': t('cat_family', 'Tre family game'),
    'Solitari': t('cat_solitari', 'Tre giochi da fare da soli'),
    '2 Giocatori': t('cat_due', 'Tre giochi per due'),
    'Cooperativi': t('cat_coop', 'Tre cooperativi'),
    'Bambini': t('cat_bambini', 'Tre giochi per i bambini'),
    'Astratti': t('cat_astratti', 'Tre astratti'),
    'Wargame': t('cat_wargame', 'Tre wargame'),
    'Party Games': t('cat_party', 'Tre party game'),
    'Puzzle Game': t('cat_puzzle', 'Tre puzzle game'),
    'Investigativo': t('cat_investigativo', 'Tre investigativi'),
    'Mazzo di carte': t('cat_carte', 'Tre giochi di carte'),
  };

  function poolFor(cat, excludeHandles) {
    return items
      .filter(function (el) {
        if (el.getAttribute('data-available') !== '1') return false;
        if (excludeHandles.indexOf(el.getAttribute('data-handle')) !== -1) return false;
        if (!cat) return el.getAttribute('data-steal') === '1';
        return (el.getAttribute('data-cats') || '').split('|').indexOf(cat) !== -1;
      })
      .map(readItem);
  }

  /* Categorie che hanno abbastanza giochi da reggere un terzetto, ordinate
     dalla piu' piccola: una nicchia e' un consiglio piu' utile di un genere
     enorme. */
  function catsUtili() {
    const conta = {};
    items.forEach(function (el) {
      if (el.getAttribute('data-available') !== '1') return;
      (el.getAttribute('data-cats') || '').split('|').filter(Boolean).forEach(function (c) {
        conta[c] = (conta[c] || 0) + 1;
      });
    });
    return Object.keys(conta)
      .filter(function (c) { return conta[c] >= 3 && CAT_TROPPO_LARGHE.indexOf(c) === -1 && CAT_FRASE[c]; })
      .sort(function (a, b) { return conta[a] - conta[b]; });
  }

  /* Tre giochi che superano la soglia con lo scarto minimo.
     Con ~15 affari veri sono al massimo qualche centinaio di combinazioni:
     le proviamo tutte, e' istantaneo e ci da' il terzetto migliore invece
     di uno qualsiasi che funziona. */
  /* Fra i terzetti che superano la soglia, scegliamo quello che fa
     RISPARMIARE DI PIU', non quello che ci arriva per il pelo. Il cliente
     compra il risparmio: "porti a casa tre giochi e ne risparmi 66" batte
     "hai centrato i 50,47". A parita' di risparmio vince chi spende meno. */
  function bestTrio(pool) {
    let best = null;
    for (let i = 0; i < pool.length - 2; i++) {
      for (let j = i + 1; j < pool.length - 1; j++) {
        for (let k = j + 1; k < pool.length; k++) {
          const trio = [pool[i], pool[j], pool[k]];
          /* Nemmeno qui due edizioni dello stesso gioco */
          const ids = trio.map(function (x) { return x.bgg; }).filter(function (x) { return x > 0; });
          if (ids.length !== new Set(ids).size) continue;
          const sum = trio.reduce(function (a, p) { return a + p.price; }, 0);
          if (sum < FREE_SHIP) continue;
          const saved = trio.reduce(function (a, p) { return a + (p.compare - p.price); }, 0);
          if (!best || saved > best.saved || (saved === best.saved && sum < best.sum)) {
            best = { picks: trio, sum: sum, saved: saved };
          }
        }
      }
    }
    return best;
  }

  /* IL BUNDLE PIU' FORTE: quanti giochi ti porti a casa restando sotto il
     tetto. Non il massimo risparmio — quello e' matematica contro un prezzo
     di listino che il cliente non sa se credere. Sei scatole sul tavolo le
     conta da solo, non deve fidarsi di nessuno.
     Espansioni escluse: non sono una serata in piu', sono un pezzo di una
     serata che hai gia'. Contarle sarebbe barare. */
  /* Stesso gioco? Il bgg_id e' l'impronta: due edizioni linguistiche dello
     stesso titolo lo condividono. Se manca (0) non possiamo saperlo e
     lasciamo passare — meglio un doppione raro che scartare meta' catalogo
     perche' il dato non c'e'. */
  function stessoGioco(p, bggVisti) {
    return p.bgg > 0 && bggVisti.indexOf(p.bgg) !== -1;
  }

  function bestCount(budgetMax) {
    const pool = items
      .filter(function (el) {
        return el.getAttribute('data-available') === '1'
          && el.getAttribute('data-exp') !== '1';
      })
      .map(readItem)
      .sort(function (a, b) { return a.price - b.price; });

    /* Dal piu' economico in su: a parita' di spesa, i piu' economici sono
       il numero massimo di scatole — che e' esattamente la promessa. */
    const picks = [];
    const bggVisti = [];
    let sum = 0;
    let i = 0;
    for (; i < pool.length; i++) {
      if (sum + pool[i].price > budgetMax) break;
      /* Mai lo stesso gioco due volte: Moon River e Moon River DE hanno lo
         stesso bgg_id. Contarli come due gonfia la promessa e in vetrina si
         vedono due scatole identiche affiancate. */
      if (stessoGioco(pool[i], bggVisti)) continue;
      picks.push(pool[i]);
      if (pool[i].bgg > 0) bggVisti.push(pool[i].bgg);
      sum += pool[i].price;
    }

    /* Il greedy puo' fermarsi SOTTO la soglia: con i giochi molto economici
       si arriva a 5 scatole per 44 €, e senza i 50 non c'e' spedizione
       gratis, quindi la promessa cade. In quel caso si scambia il piu'
       economico del gruppo con il primo che ci fa scollinare, mantenendo il
       conteggio. */
    if (sum < FREE_SHIP && picks.length > 0) {
      for (let j = i; j < pool.length; j++) {
        if (stessoGioco(pool[j], bggVisti)) continue;
        const nuovo = sum - picks[0].price + pool[j].price;
        if (nuovo >= FREE_SHIP && nuovo <= budgetMax) {
          picks.shift();
          picks.push(pool[j]);
          sum = nuovo;
          break;
        }
      }
    }

    /* Sotto la soglia o con pochi pezzi non e' piu' l'offerta che promette:
       meglio non mostrarla che mostrarne una fiacca. */
    if (sum < FREE_SHIP || sum > budgetMax || picks.length < 4) return null;
    picks.sort(function (a, b) { return b.price - a.price; });
    const saved = picks.reduce(function (a, p) { return a + (p.compare - p.price); }, 0);
    return { picks: picks, sum: sum, saved: saved };
  }

  function renderBundle(box, bundle) {
    const trio = bundle;
    const itemsBox = box.querySelector('[data-fd-trio-items]');
    const titleEl = box.querySelector('[data-fd-trio-title]');
    const sumEl = box.querySelector('[data-fd-trio-sum]');
    const addEl = box.querySelector('[data-fd-trio-add]');

    itemsBox.textContent = '';
    let saved = 0;

    trio.picks.forEach(function (p) {
      saved += (p.compare - p.price);

      const a = document.createElement('a');
      a.className = 'fd-trio__item';
      a.href = p.url;

      const img = document.createElement('img');
      img.className = 'fd-trio__img';
      img.src = p.img;
      img.alt = p.title;
      img.loading = 'lazy';

      const meta = document.createElement('div');
      meta.className = 'fd-trio__meta';

      const nm = document.createElement('span');
      nm.className = 'fd-trio__name';
      nm.textContent = p.title;

      const pr = document.createElement('span');
      pr.className = 'fd-trio__price';
      pr.textContent = money(p.price) + ' · −' + p.disc + '%';

      meta.appendChild(nm);
      meta.appendChild(pr);

      /* Il genere sulla card: se uno guarda il bundle e si chiede "e questo
         cos'e'?", il bundle ha gia' perso. Qui ha tutte le risposte. */
      const g = (p.cats || []).filter(function (c) {
        return ['Strategia', 'Competitivo', 'Tematici'].indexOf(c) === -1;
      })[0] || (p.cats || [])[0];
      if (g) {
        const gs = document.createElement('span');
        gs.className = 'fd-trio__genre';
        gs.textContent = g;
        meta.appendChild(gs);
      }
      a.appendChild(img);
      a.appendChild(meta);
      itemsBox.appendChild(a);
    });

    titleEl.textContent = bundle.frase;

    const kickerEl = box.querySelector('[data-fd-trio-kicker]');
    if (kickerEl && bundle.kicker) kickerEl.textContent = bundle.kicker;

    /* Due numeri, non uno. Prima "risparmi 100 €" urlava e "84,97 € in tutto"
       stava in grigetto: rispondevo alla domanda sbagliata. Chi guarda un
       bundle ne fa due — cosa mi porto a casa, e quanto pago — e vanno
       risposte tutte e due con la stessa forza. */
    const savedEl = box.querySelector('[data-fd-trio-saved]');
    if (savedEl) savedEl.textContent = money(saved);
    const priceEl = box.querySelector('[data-fd-trio-price]');
    if (priceEl) priceEl.textContent = money(trio.sum);
    const countEl = box.querySelector('[data-fd-trio-count]');
    if (countEl) countEl.textContent = trio.picks.length;
    /* La spedizione gratis si promette SOLO se il totale la raggiunge. Il set
       completo (Riftforce + Beyond = 24 €) non ci arriva, e la sua leva non e'
       la spedizione: e' avere il gioco intero. Prometterla sarebbe falso. */
    sumEl.textContent = trio.sum >= FREE_SHIP ? t('sped_gratis', 'spedizione gratis') : '';
    addEl.setAttribute('data-ids', trio.picks.map(function (p) { return p.variantId; }).join(','));
    box.hidden = false;
    setupRail(box);
  }

  /* ---------- Il binario ----------
     La fila scorre, ma deve DIRLO: frecce + "1–7 di 14" nell'intestazione,
     sfumatura sul bordo dove c'è altro, barra di avanzamento sotto.
     Tutto locale: nessuna chiamata di rete, un listener di scroll per fila,
     e scrive solo attributi sul binario, mai dentro la fila che osserva. */
  function setupRail(box) {
    const rail = box.querySelector('[data-fd-rail]');
    const row = box.querySelector('[data-fd-trio-items]');
    const nav = box.querySelector('[data-fd-rail-nav]');
    if (!rail || !row || !nav) return;
    const pos = nav.querySelector('[data-fd-rail-pos]');
    const prev = nav.querySelector('[data-fd-rail-prev]');
    const next = nav.querySelector('[data-fd-rail-next]');
    const thumb = rail.querySelector('[data-fd-rail-thumb]');

    function update() {
      const max = row.scrollWidth - row.clientWidth;
      const has = max > 8;
      nav.hidden = !has;
      rail.setAttribute('data-has-more', has ? '1' : '0');
      if (!has) {
        rail.setAttribute('data-more-start', '0');
        rail.setAttribute('data-more-end', '0');
        return;
      }
      const x = row.scrollLeft;
      const atStart = x <= 4;
      const atEnd = x >= max - 4;
      rail.setAttribute('data-more-start', atStart ? '0' : '1');
      rail.setAttribute('data-more-end', atEnd ? '0' : '1');
      prev.setAttribute('aria-disabled', atStart ? 'true' : 'false');
      next.setAttribute('aria-disabled', atEnd ? 'true' : 'false');

      /* "1–7 di 14": conta le card visibili PER INTERO, quella tagliata sul
         bordo non conta — è lei il segnale che c'è altro. */
      const kids = row.children;
      let first = -1, last = -1;
      for (let i = 0; i < kids.length; i++) {
        const l = kids[i].offsetLeft, r = l + kids[i].offsetWidth;
        if (l >= x - 2 && r <= x + row.clientWidth + 2) {
          if (first === -1) first = i;
          last = i;
        }
      }
      if (first === -1) { first = last = Math.round(x / (kids[0] ? kids[0].offsetWidth + 10 : 1)); }
      if (pos) pos.textContent = (first + 1) + '–' + (last + 1) + ' ' + t('di', 'di') + ' ' + kids.length;

      if (thumb) {
        thumb.style.width = (row.clientWidth / row.scrollWidth * 100) + '%';
        thumb.style.left = (x / row.scrollWidth * 100) + '%';
      }
    }

    /* Pagina alla Steam, allineata alle card: avanti, la card tagliata sul
       bordo diventa la prima; indietro, la prima di adesso diventa l'ultima.
       Mai mezza card a sinistra dopo un clic. */
    function go(dir) {
      const kids = row.children;
      const x = row.scrollLeft, cw = row.clientWidth;
      let target = x + dir * cw * 0.85;
      for (let i = 0; i < kids.length; i++) {
        const l = kids[i].offsetLeft, r = l + kids[i].offsetWidth;
        if (dir > 0 && r > x + cw + 2) { target = l; break; }
        if (dir < 0 && l >= x - 2) { target = r - cw; break; }
      }
      const reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      row.scrollTo({ left: Math.max(0, target), behavior: reduce ? 'auto' : 'smooth' });
    }
    if (!row.hasAttribute('data-rail-bound')) {
      row.setAttribute('data-rail-bound', '1');
      row.addEventListener('scroll', update, { passive: true });
      prev.addEventListener('click', function () { go(-1); });
      next.addEventListener('click', function () { go(1); });
    }
    box._fdRailUpdate = update;
    /* Subito, non al frame dopo: il box e' appena diventato visibile e il
       layout c'e' gia'. Il secondo giro al frame successivo copre font e
       immagini che cambiano misura. */
    update();
    requestAnimationFrame(update);
  }

  let railResizeT = null;
  window.addEventListener('resize', function () {
    clearTimeout(railResizeT);
    railResizeT = setTimeout(function () {
      trios.forEach(function (b) { if (!b.hidden && b._fdRailUpdate) b._fdRailUpdate(); });
    }, 120);
  });

  /* ---------- La scala dei bundle ----------
     Non "quanti tipi ne aggiungo" ma "quale scala di forza". I generatori
     sono in ordine dal piu' forte al piu' debole; ogni box della pagina
     prende il primo bundle che questo catalogo riesce a riempire, senza
     riusare giochi gia' impacchettati. Se un tipo non si riempie (pochi
     giochi, o nessuno arriva a 50), si scende al successivo.
     A prova di rotazione: il mese prossimo un catalogo di giochi costosi
     riempira' "2 giochi", uno di giochi economici riempira' "tanti giochi".
     La pagina si adatta invece di mostrare bundle vuoti. */

  const TIPO_FRASI = {
    'Deck-building game': [t('tf_deck', 'Tre deck-building'), t('tk_deck', 'Stessa meccanica')],
    'Roll & Write': [t('tf_rw', 'Tre roll & write'), t('tk_rw', 'Carta e matita')],
    'Legacy / Campagna': [t('tf_legacy', 'Tre campagne'), t('tk_legacy', 'Una storia lunga')],
    'Escape Room / Puzzle': [t('tf_escape', 'Tre da risolvere'), t('tk_escape', 'Enigmi')],
    'Gioco narrativo': [t('tf_narr', 'Tre giochi narrativi'), t('tk_narr', 'Una storia')],
    'Gioco cooperativo': [t('tf_coop', 'Tre cooperativi'), t('tk_coop', 'Tutti insieme')],
  };
  const GENERE_FRASI = {
    'Family': [t('gf_family', 'Tre family game'), t('gk_family', 'Da tavolo con tutti')],
    'Astratti': [t('gf_astratti', 'Tre astratti'), t('gk_astratti', 'Solo testa')],
    'Wargame': [t('gf_wargame', 'Tre wargame'), t('gk_wargame', 'Sul campo')],
    'Party Games': [t('gf_party', 'Tre party game'), t('gk_party', 'In compagnia')],
  };

  /* Giochi disponibili, non espansioni, non gia' usati */
  function libera(used, extra) {
    return items
      .filter(function (el) {
        return el.getAttribute('data-available') === '1'
          && el.getAttribute('data-exp') !== '1'
          && used.indexOf(el.getAttribute('data-handle')) === -1;
      })
      .map(readItem)
      .filter(extra || function () { return true; });
  }

  /* Un terzetto a tema: se non si riempie, ritorna null e la scala scende. */
  function trioTema(used, pred, frase, kicker) {
    const t = bestTrio(libera(used, pred));
    if (!t) return null;
    return { picks: t.picks, sum: t.sum, frase: frase, kicker: kicker };
  }

  /* DUE giochi che fanno la spedizione gratis. Per la meta' alta del
     catalogo e' piu' forte del "tanti giochi": due scatole da 25-40 € sono
     un ordine piu' ricco di sei da 8 €. */
  function bestPair(used) {
    const pool = libera(used).sort(function (a, b) { return a.price - b.price; });
    let best = null;
    for (let i = 0; i < pool.length - 1; i++) {
      for (let j = i + 1; j < pool.length; j++) {
        if (pool[i].bgg > 0 && pool[i].bgg === pool[j].bgg) continue;
        const sum = pool[i].price + pool[j].price;
        if (sum < FREE_SHIP) continue;
        if (!best || sum < best.sum) best = { picks: [pool[i], pool[j]], sum: sum };
      }
    }
    if (!best) return null;
    return { picks: best.picks, sum: best.sum, frase: t('due_giochi', 'Due giochi, spedizione gratis'), kicker: t('due_bastano', 'Due bastano') };
  }

  /* COMPLETA LA COLLEZIONE: base + la sua espansione. La leva non e' la
     spedizione (Riftforce + Beyond = 24 €), e' avere il gioco intero.
     Riconosco la famiglia dal prefisso del titolo, e richiedo che ci sia
     ALMENO un'espansione: due giochi diversi con lo stesso prefisso
     (Side Quest: Frostpunk / Nemesis) NON sono un set. */
  function prefissoTitolo(t) {
    return t.split(/ [-–:] /)[0].trim().toLowerCase();
  }
  function completaSet(used) {
    const disponibili = items
      .filter(function (el) { return el.getAttribute('data-available') === '1'; })
      .map(readItem);
    const out = [];
    disponibili.forEach(function (base) {
      if (base.exp) return;
      if (used.indexOf(base.handle) !== -1) return;
      const pref = prefissoTitolo(base.title);
      const esp = disponibili.filter(function (p) {
        return p.exp && used.indexOf(p.handle) === -1 && prefissoTitolo(p.title) === pref;
      });
      if (!esp.length) return;
      const picks = [base].concat(esp);
      const sum = picks.reduce(function (a, p) { return a + p.price; }, 0);
      const molte = esp.length > 1;
      out.push({
        picks: picks, sum: sum,
        frase: base.title + (molte ? t('espansioni', ' e le sue espansioni') : t('espansione', ' e la sua espansione')),
        kicker: t('set_completo', 'Il set completo'),
      });
    });
    return out.slice(0, 2);
  }

  function buildTrios() {
    const used = [];
    const claim = function (b) { b.picks.forEach(function (p) { used.push(p.handle); }); return b; };

    /* HERO: il carrello pieno, "N giochi". Massimo impatto visivo, va in cima
       e si prende tutta la larghezza. */
    let hero = null;
    const hc = bestCount(Math.round(FREE_SHIP * 1.3));
    if (hc) {
      hero = claim({ picks: hc.picks, sum: hc.sum, frase: t('n_giochi_gratis', '{{ n }} giochi, spedizione gratis').replace('{{ n }}', hc.picks.length), kicker: t('carrello_pieno', 'Il carrello pieno') });
    }

    /* La coda, in ordine di forza. Ogni generatore usa solo giochi ancora
       liberi e marca i suoi. */
    const coda = [];
    const push = function (b) { if (b) { coda.push(claim(b)); } };
    const pushAll = function (arr) { arr.forEach(push); };

    pushAll(completaSet(used));
    push(bestPair(used));

    Object.keys(TIPO_FRASI).forEach(function (t) {
      push(trioTema(used, function (p) { return p.tipo.indexOf(t) !== -1; }, TIPO_FRASI[t][0], TIPO_FRASI[t][1]));
    });
    push(trioTema(used, function (p) { return p.pmax > 0 && p.pmax <= 2; }, t('f_due', 'Tre giochi per due'), t('k_due', 'Per due')));
    push(trioTema(used, function (p) { return p.eta > 0 && p.eta <= 8; }, t('f_piccoli', 'Tre giochi per i più piccoli'), t('k_piccoli', 'Regalo')));
    push(trioTema(used, function (p) {
      return p.cats.indexOf('Solitari') !== -1 || p.tipo.indexOf('Gioco in solitario') !== -1;
    }, 'Tre da giocare in solitaria', 'Da soli'));
    Object.keys(GENERE_FRASI).forEach(function (g) {
      push(trioTema(used, function (p) { return p.cats.indexOf(g) !== -1; }, GENERE_FRASI[g][0], GENERE_FRASI[g][1]));
    });
    push(trioTema(used, function (p) { return p.lingua.indexOf('Italiano') !== -1; }, t('f_ita', 'Tre giochi in italiano'), t('k_ita', 'In italiano')));

    /* Ultimo ripiego: tre affari veri senza tema. Prende sempre finche' c'e'
       roba, cosi' un box non resta mai vuoto se ci sono giochi. */
    let extra = bestTrio(libera(used));
    while (extra) {
      coda.push(claim({ picks: extra.picks, sum: extra.sum, frase: t('tre_insieme', 'Tre da prendere insieme'), kicker: t('insieme', 'Insieme') }));
      extra = bestTrio(libera(used));
    }

    /* Riempi i box: hero in cima, poi la coda nell'ordine della scala. */
    trios.forEach(function (box, idx) {
      const b = (idx === 0 && hero) ? hero : coda.shift();
      if (!b) { box.hidden = true; return; }
      renderBundle(box, b);
    });
  }

  /* ---------- Disponibilita' live ----------
     Le scorte sono 1-3 copie e l'app sposta gli esauriti in fondo solo al
     giro dopo: senza questo, un terzetto puo' consigliare roba gia' venduta. */
  function sweepSteals() {
    const steals = items.filter(function (el) { return el.getAttribute('data-steal') === '1'; });
    return Promise.all(steals.map(function (el) {
      return fetch('/products/' + encodeURIComponent(el.getAttribute('data-handle')) + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) {
          if (p && p.available === false) el.setAttribute('data-available', '0');
        })
        .catch(function () { /* offline: teniamo lo stato Liquid */ });
    }));
  }

  /* ---------- 2. Barra carrello ---------- */
  function pickFiller(remaining, inCart) {
    let best = null;
    items.forEach(function (el) {
      if (el.getAttribute('data-available') !== '1') return;
      const handle = el.getAttribute('data-handle');
      if (inCart.indexOf(handle) !== -1) return;
      const price = n(el, 'data-price');
      if (price < remaining) return; /* non chiude il buco */
      if (!best || price < best.price) {
        best = { price: price, title: el.getAttribute('data-title'), variantId: el.getAttribute('data-variant-id') };
      }
    });
    return best;
  }

  function refreshBar() {
    if (!bar) return;
    fetch('/cart.js')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        if (!cart || cart.item_count === 0) { bar.hidden = true; return; }

        const msg = bar.querySelector('[data-fd-bar-msg]');
        const fill = bar.querySelector('[data-fd-bar-fill]');
        const savedEl = bar.querySelector('[data-fd-bar-saved]');
        const addBtn = bar.querySelector('[data-fd-bar-add]');
        const total = cart.total_price;

        bar.hidden = false;
        if (fill) fill.style.width = Math.min(100, Math.round((total / FREE_SHIP) * 100)) + '%';

        /* Il risparmio come trofeo: su un cesto di sconti e' la cosa che
           stanno comprando davvero. line_price e' il listino, final_line_price
           il pagato: la differenza e' il risparmio vero, sconti inclusi. */
        let saved = 0;
        (cart.items || []).forEach(function (i) {
          saved += ((i.original_line_price || i.line_price) - i.final_line_price);
        });
        if (savedEl) {
          savedEl.hidden = saved <= 0;
          savedEl.textContent = saved > 0 ? t('bar_risparmio', 'Stai risparmiando {{ x }}').replace('{{ x }}', money(saved)) : '';
        }

        if (total >= FREE_SHIP) {
          bar.setAttribute('data-state', 'free');
          msg.textContent = t('bar_gratis', 'Spedizione gratis · totale {{ x }}').replace('{{ x }}', money(total));
          addBtn.hidden = true;
          return;
        }

        const remaining = FREE_SHIP - total;
        const inCart = (cart.items || []).map(function (i) { return i.handle; });
        const filler = pickFiller(remaining, inCart);

        bar.setAttribute('data-state', 'near');
        msg.textContent = t('bar_mancano', '{{ tot }} · ti mancano {{ x }} per la spedizione gratis').replace('{{ tot }}', money(total)).replace('{{ x }}', money(remaining));

        if (filler) {
          addBtn.hidden = false;
          addBtn.textContent = '+ ' + filler.title + ' · ' + money(filler.price);
          addBtn.setAttribute('data-ids', filler.variantId);
        } else {
          addBtn.hidden = true;
        }
      })
      .catch(function () { /* offline: la barra resta com'e' */ });
  }

  /* ---------- Carrello ----------
     `open: true` non e' un dettaglio. Prima era false: i giochi entravano
     davvero nel carrello (verificato: status 200, totale aggiornato) ma a
     schermo non succedeva niente, e la cosa si leggeva come "il bottone e'
     rotto". Un successo silenzioso e' un fallimento: se uno clicca
     "Aggiungi tutti e tre", il carrello deve aprirsi e mostrarglieli. */
  function addIds(ids, openDrawer) {
    const list = ids.split(',').filter(Boolean).map(function (id) {
      return { id: parseInt(id, 10), quantity: 1 };
    });
    if (!list.length) return Promise.resolve();
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: list }),
    }).then(function (r) {
      if (!r.ok) throw new Error('cart add failed: ' + r.status);
      document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: openDrawer === true } }));
      refreshBar();
    });
  }

  document.addEventListener('click', function (e) {
    const btn = e.target.closest('[data-fd-trio-add], [data-fd-bar-add]');
    if (!btn) return;
    e.preventDefault();
    const ids = btn.getAttribute('data-ids');
    if (!ids) return;

    /* Il terzetto apre il carrello: e' un gesto grosso e voluto, tre giochi
       insieme, e merita di vederli atterrare. Il riempitivo della barra no:
       li' stai ancora scegliendo e un drawer in faccia interrompe. */
    const isTrio = !!btn.closest('[data-fd-trio]');

    const original = btn.textContent;
    btn.disabled = true;
    btn.textContent = t('aggiungo', 'Aggiungo...');
    addIds(ids, isTrio)
      .then(function () { btn.textContent = t('aggiunto', 'Aggiunto ✓'); })
      .catch(function (err) {
        console.error('[FrogDeal]', err);
        btn.textContent = t('errore', 'Errore, riprova');
      })
      .then(function () {
        setTimeout(function () { btn.disabled = false; btn.textContent = original; }, 1800);
      });
  });

  /* ---------- Indice del fondo ----------
     Chi arriva in fondo ha scorso tutto senza comprare: e' la persona piu'
     difficile della pagina e sta uscendo. Rimandarla in cima le fa rifare la
     stessa strada; l'indice la manda dove le serve.
     Costruito leggendo le zone VERE nel DOM: la collezione ruota, quindi un
     indice scritto a mano avrebbe voci morte il mese prossimo. */
  function buildJump() {
    const nav = document.querySelector('[data-fd-jump]');
    if (!nav) return;
    const box = nav.querySelector('[data-fd-jump-links]');
    const zones = Array.prototype.slice.call(root.querySelectorAll('.fd-zone'));
    if (!box || zones.length === 0) return;

    box.textContent = '';
    let n = 0;
    zones.forEach(function (z, i) {
      const t = z.querySelector('.fd-zone__title');
      if (!t || !t.textContent.trim()) return;
      const id = 'fd-z-' + i;
      z.id = id;

      const a = document.createElement('a');
      a.className = 'fd-jump__link';
      a.href = '#' + id;
      a.textContent = t.textContent.trim();
      box.appendChild(a);
      n++;
    });
    nav.hidden = n === 0;
  }

  /* ---------- Go ---------- */
  function init() {
    buildTrios();
    buildJump();
    refreshBar();

    /* La disponibilita' vera puo' cambiare i terzetti: li rifacciamo dopo */
    sweepSteals().then(buildTrios);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
